<template>
  <div class="account-settings">
    <v-col cols="12" class="px-0">
      <v-row v-if="busy">
        <div
          class="d-flex mx-auto flex-column align-items-center justify-content-center mt-8 py-6"
        >
          <spring-spinner
            :animation-duration="1500"
            :size="60"
            color="#bf0000"
            class="mx-auto"
          />
          <h3 class="mt-6 primary--text">در حال بارگذاری...</h3>
        </div>
      </v-row>
      <v-row v-else>
        <v-col cols="12" md="3">
          <v-card class="items-container d-flex pa-5">
            <h4>{{ userName }}</h4>
            <div
              v-if="isUploading"
              class="ma-10 d-flex flex-column justify-content-center align-center"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              <h5 class="mt-3">در حال بارگذاری...</h5>
            </div>
            <div v-else class="profile-img mt-5 mb-10">
              <img v-if="userDetails.mediaId" :src="userDetails.mediaUrl" />
              <v-gravatar v-else :email="userDetails.email" />
            </div>
            <v-tabs vertical v-model="tab">
              <v-tab>
                <v-icon class="me-2"> mdi-account </v-icon>
                حساب کاربری
              </v-tab>
              <v-tab class="my-2">
                <v-icon class="me-1"> mdi-circle-slice-7 </v-icon>
                کیک‌های سهام من
              </v-tab>
              <v-tab>
                <v-icon class="me-1"> mdi-lock </v-icon>
                تغییر رمز عبور
              </v-tab>
            </v-tabs>
          </v-card>
        </v-col>
        <v-col cols="12" md="9">
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card class="pa-3">
                <v-card-title>جزئیات حساب کاربری</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <div class="warning-div w-100 pa-4 text-center">
                        <h4>
                          این تنظیمات، تنظیمات کلی شما می‌باشد. تنظیمات مربوط به
                          کیک سهام (مانند حقوق) تنها توسط صاحب کیک سهام قابل
                          تغییر است.
                        </h4>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h4 class="mb-2">نام و نام خانوادگی</h4>
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        color="#444"
                        v-model="userDetails.name"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <div
                    class="red--text my-1 fs-xxsmall font-weight-bold"
                    v-if="!validUserName"
                  >
                    <v-icon class="red--text">mdi-alert-outline</v-icon> نام و
                    نام خانوادگی کاربر نمیتواند بیشتر از 20 کاراکتر باشد!
                  </div>
                  <v-row>
                    <v-col>
                      <h4 class="mb-2">ایمیل</h4>
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        color="#444"
                        v-model="userDetails.email"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h4 class="mb-2">عکس حساب کاربری</h4>
                      <v-file-input
                        outlined
                        dense
                        prepend-icon=""
                        hide-details
                        ref="uploadFile"
                        v-model="file"
                        :placeholder="
                          userDetails.mediaId
                            ? userDetails.mediaName
                            : 'فایلی انتخاب نشده‌ است'
                        "
                        @change="uploadFile(file)"
                        :disabled="isUploading"
                      >
                        <template slot="append">
                          <v-btn
                            class="upload-btn"
                            :disabled="isUploading"
                            @click="$refs.uploadFile.$refs.input.click()"
                          >
                            <h5 class="grey--text text--darken-1">
                              انتخاب فایل
                            </h5>
                          </v-btn>
                        </template>
                      </v-file-input>
                      <h5 class="text--disabled mt-2">
                        فرمت‌های قابل بارگذاری: png و jpg. حداکثر حجم بارگذاری
                        2MB می‌باشد.
                      </h5>
                      <div v-if="isUploading" class="mt-4">
                        <v-progress-linear
                          rounded
                          v-if="myFile.showProgress"
                          height="10"
                          :value="myFile.uploadPercentage"
                          class="mb-4 mt-0"
                        >
                        </v-progress-linear>
                        در حال بارگذاری...
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mb-2 mt-6">
                    <v-col
                      class="d-flex flex-sm-row flex-column justify-space-between"
                    >
                      <v-btn
                        class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
                        @click="editData()"
                        :loading="editBusy"
                        :disabled="!userDetails.name || !validUserName"
                      >
                        <v-icon class="me-1">mdi-check-bold</v-icon>
                        ذخیره‌سازی تغییرات
                      </v-btn>
                      <!--<v-btn
                        class="primary white--text mx-sm-0 mx-auto"
                        @click="
                          deleteDialog = true;
                          passForDelete = '';
                        "
                      >
                        <v-icon class="me-1">mdi-trash-can</v-icon>
                        حذف حساب و پاک کردن اطلاعات
                      </v-btn>-->
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-dialog v-model="deleteDialog" max-width="700">
                  <v-card class="pa-2">
                    <v-card-title class="mb-4">
                      حذف حساب کاربری و پاک کردن اطلاعات
                    </v-card-title>
                    <v-card-text class="px-2"> <MVPInfo /> </v-card-text>
                    <v-card-actions>
                      <v-btn
                        class="ms-auto primary white--text"
                        @click="deleteDialog = false"
                        >فهمیدم!</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card class="px-md-4 px-0" flat>
                <v-card-title>کیک‌های سهام من</v-card-title>
                <v-card-text>
                  <div class="custom-table">
                    <v-data-table
                      :headers="Fields"
                      :items="pieList"
                      :hide-default-footer="true"
                      :page.sync="CurrentPage"
                      :items-per-page="PerPage"
                    >
                      <template v-slot:[`item.status`]="{ item }">
                        {{ item.status == "active" ? "فعال" : "غیرفعال" }}
                      </template>
                      <template v-slot:[`item.userRole`]="{ item }">
                        {{ item.userRole == "manager" ? "مدیر" : "کارمند" }}
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-btn
                          class="primary white--text"
                          @click="openDialog(item)"
                          >بازنشانی/ حذف کیک سهام</v-btn
                        >
                      </template>
                      <template v-slot:no-data>
                        <p class="mt-5">موردی برای نمایش وجود ندارد.</p>
                      </template>
                    </v-data-table>

                    <v-pagination
                      v-model="CurrentPage"
                      :length="Math.ceil(totalRows / PerPage)"
                      :total-visible="5"
                      prev-icon="mdi-arrow-left"
                      next-icon="mdi-arrow-right"
                      class="mt-8"
                    ></v-pagination>
                  </div>
                  <v-dialog v-model="removeDialog" width="700">
                    <v-card class="px-0">
                      <v-card-title class="mb-4">
                        بازنشانی/ حذف کیک سهام
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-4">برای حذف کیک سهام و لغو اشتراک:</h4>
                        <ul class="ps-8">
                          <li>به صفحه اصلی کیک سهام بروید</li>
                          <li>
                            بر روی
                            <v-icon>mdi-cog</v-icon>
                            کنار نام کیک سهام کلیک کنید
                          </li>
                          <li>بر روی گزینه "حذف" در پایین صفحه کلیک کنید</li>
                        </ul>

                        <p class="mt-4 text-justify">
                          شما همچنین میتوانید با کلیک بر روی دکمه "بازنشانی" به
                          جای "حذف"، کیک خود را مجددا تنظیم کنید. این ویژگی به
                          شما این امکان را می‌دهد که از کیک سهام موردنظر برای یک
                          شرکت دیگر استفاده کنید و اشتراک خود را با همان قیمت
                          نگه‌دارید. پس اگر قیمت‌ها بالا رود، نیازی به پرداخت
                          بیشتر برای کیک سهام بعدی نیست! توجه داشته باشید که شما
                          تنها می‌توانید کیک‌های سهامی را بازنشانی یا حذف نمایید
                          که خودتون سازنده آن‌ها باشید و این امکان برای کیک‌های
                          سهامی که تنها در آن عضو هستید وجود ندارد.
                        </p>
                        <v-row class="mt-5">
                          <v-col
                            class="d-flex flex-sm-row flex-column justify-space-between"
                          >
                            <v-btn
                              class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
                              :to="'/home/' + selected.id"
                            >
                              <v-icon class="me-1">mdi-check-bold</v-icon>
                              مشاهده کیک سهام
                            </v-btn>
                            <v-btn
                              class="primary white--text mx-sm-0 mx-auto"
                              @click="removeDialog = false"
                            >
                              <v-icon class="me-1">mdi-close-thick</v-icon>
                              بستن
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-title>تغییر رمز عبور</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h4 class="mb-2">رمز عبور فعلی</h4>
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        color="#444"
                        type="password"
                        v-model="oldPassword"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h4 class="mb-2">رمز عبور جدید</h4>
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        color="#444"
                        type="password"
                        v-model="newPassword"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h4 class="mb-2">تکرار رمز عبور جدید</h4>
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        color="#444"
                        type="password"
                        v-model="newPasswordRepeat"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn
                        class="primary white--text"
                        @click="changePassword()"
                        :loading="passBusy"
                        :disabled="
                          !oldPassword || !newPassword || !newPasswordRepeat
                        "
                      >
                        <v-icon class="me-1">mdi-check-bold</v-icon>
                        تغییر رمز عبور
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import md5 from "js-md5";
import { SpringSpinner } from "epic-spinners";
const MVPInfo = () => import("@/components/MVPInfo");
import { mapMutations } from "vuex";
export default {
  components: {
    SpringSpinner,
    MVPInfo,
  },
  data() {
    return {
      tab: null,
      role: "",
      CurrentPage: 1,
      PerPage: 10,
      busy: false,
      totalRows: "",
      Fields: [
        { value: "name", text: "نام کیک سهام", sortable: false },
        { value: "status", text: "وضعیت", sortable: false },
        { value: "userRole", text: "نقش", sortable: false },
        { value: "actions", text: "عملیات", sortable: false },
      ],

      selected: {},
      removeDialog: false,
      userDetails: {},
      file: [],
      editBusy: false,
      deleteDialog: false,
      passForDelete: "",
      deleteBusy: false,
      passBusy: false,
      oldPassword: "",
      newPassword: "",
      newPasswordRepeat: "",
      myFile: new Object({
        uploadPercentage: 0,
      }),
      isUploading: false,
      pieList: [],
      userName: "",
    };
  },
  methods: {
    ...mapMutations(["setUserName"]),
    openDialog(item) {
      this.selected = item;
      this.removeDialog = true;
    },
    getInfo() {
      this.busy = true;
      this.$http
        .get(this.baseUrl + "/user/getData", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.userDetails = res.data.user;
            this.pieList = res.data.userPies;
            this.userName = res.data.user.name;
            this.totalRows = this.pieList.length;
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    editData() {
      this.editBusy = true;
      this.$http
        .patch(
          this.baseUrl + "/user/edit",
          {
            name: this.userDetails.name,
            email: this.userDetails.email,
            mediaId: this.userDetails.mediaId ? this.userDetails.mediaId : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.editBusy = false;
            this.setUserName(this.userDetails.name);
            localStorage.setItem("name", this.userDetails.name);
            this.getInfo();
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.editBusy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.editBusy = false;
        });
    },
    deleteUser() {
      this.deleteBusy = true;
      this.$http
        .delete(
          this.baseUrl +
            "/" +
            this.role +
            "/user/delete/" +
            md5(this.passForDelete),
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.$router.push("/login");
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.deleteBusy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.deleteBusy = false;
        });
    },
    changePassword() {
      this.passBusy = true;
      this.$http
        .patch(
          this.baseUrl + "/user/changePassword",
          {
            newPassword: md5(this.newPassword),
            newPasswordRepeat: md5(this.newPasswordRepeat),
            oldPassword: md5(this.oldPassword),
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.oldPassword = "";
            this.newPassword = "";
            this.newPasswordRepeat = "";
            this.passBusy = false;
          } else {
            this.passBusy = false;
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.passBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    uploadFile(file) {
      let sizeMB = file.size / 1024 / 1024;
      if (sizeMB > 2) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 2 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد. ", "error");
        return;
      } else {
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.isUploading = true;
        this.$http
          .post(this.baseUrl + "/user/uploadFile", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
            onUploadProgress: ((progressEvent) => {
              this.myFile.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.userDetails.mediaId = d.data.id;
              this.userDetails.mediaUrl = d.data.url;
              this.isUploading = false;
              this.toast(d.data.message, "success");
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.response.data, "error");
            this.isUploading = false;
          });
      }
    },
  },
  computed: {
    validUserName() {
      if (this.userDetails.name && this.userDetails.name.length > 20) {
        return false;
      } else return true;
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.getInfo();
  },
};
</script>

<style lang="scss">
.v-tabs-bar__content {
  width: 100% !important;
}
</style>
